import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00325 = new TileLayer({
  title: 'Máscara 19981019',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19981019l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00325.setVisible(false);

const layer00324 = new TileLayer({
  title: 'Máscara 19981120',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19981120l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00324.setVisible(false);

const layer00323 = new TileLayer({
  title: 'Máscara 19981206',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19981206l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00323.setVisible(false);

const layer00322 = new TileLayer({
  title: 'Máscara 19981222',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19981222l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00322.setVisible(false);

const layer00321 = new TileLayer({
  title: 'Máscara 19990107',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990107l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00321.setVisible(false);

const layer00320 = new TileLayer({
  title: 'Máscara 19990208',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990208l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00320.setVisible(false);

const layer00319 = new TileLayer({
  title: 'Máscara 19990413',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990413l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00319.setVisible(false);

const layer00318 = new TileLayer({
  title: 'Máscara 19990531',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990531l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00318.setVisible(false);

const layer00317 = new TileLayer({
  title: 'Máscara 19990616',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990616l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00317.setVisible(false);

const layer00316 = new TileLayer({
  title: 'Máscara 19990827',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19990827l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00316.setVisible(false);

export const grupoCapa01_23 = new LayerGroup({
  title: 'Ciclo Hidrológico 1998-1999',
  fold: 'close',
  layers: [layer00316, layer00317, layer00318, layer00319, layer00320, layer00321, layer00322, layer00323, layer00324, layer00325]
});